import React, { useState } from 'react'
import { bool, func, number } from 'prop-types'
import Modal from '../Modal/Modal'
import IcoHeart from '../icons/IcoHeart'
import IcoCheck from '../icons/IcoCheck'
import { BtnGhost, BtnOrange, BtnPrimary } from '../ui/buttons'
import { theme } from '../../styles'
import { Callout, SuccessBox, SuccessSeal, ErroMsg } from './cancel-flow-styles'

export default function UndoCancelFlow( { podeRenovar, edicaoRenovacao, onRenew, onUndo, onClose } ) {
  const [ submitting, setSubmitting ] = useState( false )
  const [ erro, setErro ] = useState( false )
  const [ done, setDone ] = useState( false )

  const confirmar = async() => {
    setErro( false )
    setSubmitting( true )
    try {
      await onUndo()
      setDone( true )
    } catch ( falha ) {
      setErro( true )
      setSubmitting( false )
    }
  }

  if ( done ) {
    return (
      <Modal
        footer={ (
          <>
            <BtnGhost
              onClick={ onClose }
              type="button"
            >
              Entendi
            </BtnGhost>
            { podeRenovar ? (
              <BtnOrange
                onClick={ onRenew }
                type="button"
              >
                Renovar agora
              </BtnOrange>
            ) : null }
          </>
        ) }
        onClose={ onClose }
        title="Cancelamento desfeito"
      >
        <SuccessBox>
          <SuccessSeal $orange>
            <IcoCheck
              height="22"
              style={{ 'color': '#fff' }}
              width="22"
            />
          </SuccessSeal>
          <p>Sua solicitação de cancelamento foi desfeita e sua assinatura segue ativa!</p>
          <p>
            <b>Sua renovação automática ainda não aconteceu?</b>
            <br />
            Sua assinatura será renovada automaticamente na data informada.
          </p>
          { podeRenovar ? (
            <p>
              <b>A data da renovação automática já passou?</b>
              <br />
              Será necessário renovar sua assinatura{ edicaoRenovacao ? ` para ${edicaoRenovacao}` : '' }.
              Clique em Renovar agora e finalize a renovação.
            </p>
          ) : null }
        </SuccessBox>
      </Modal>
    )
  }

  const footer = (
    <>
      <BtnGhost
        disabled={ submitting }
        onClick={ onClose }
        type="button"
      >Voltar
      </BtnGhost>
      <BtnPrimary
        disabled={ submitting }
        onClick={ confirmar }
        type="button"
      >
        { submitting ? 'Processando…' : 'Desfazer cancelamento' }
      </BtnPrimary>
    </>
  )

  return (
    <Modal
      canClose={ !submitting }
      eyebrow="Assinatura"
      footer={ footer }
      onClose={ onClose }
      sub="Sua assinatura está em processo de cancelamento. Quer voltar atrás?"
      title="Desfazer cancelamento"
    >
      <Callout>
        <IcoHeart
          height="20"
          style={{ 'color': theme.cores.accent, 'flex': 'none' }}
          width="20"
        />
        <span>
          Ao desfazer, sua assinatura volta a seguir ativa normalmente, com
          renovação e acesso à comunidade e aos conteúdos do clube mantidos.
        </span>
      </Callout>
      { erro ? (
        <ErroMsg>Não foi possível desfazer o cancelamento agora. Tente novamente em instantes.</ErroMsg>
      ) : null }
    </Modal>
  )
}

UndoCancelFlow.propTypes = {
  'podeRenovar': bool,
  'edicaoRenovacao': number,
  'onRenew': func,
  'onUndo': func.isRequired,
  'onClose': func.isRequired
}

UndoCancelFlow.defaultProps = {
  'podeRenovar': false,
  'edicaoRenovacao': null,
  'onRenew': null
}
